import { AntDropdown, Icons, Progress } from '@agro-club/agroclub-shared'
import { useNotification } from 'hooks/useNotification'
import { Deal, DealStatusTypes } from 'modules/domain/deal/types'
import { useTranslation } from 'react-i18next'
import { AButton } from 'views/components/Analytics'
import { TooltipIcon } from 'views/components/TooltipIcons/TooltipIcons'
import { formatCoordinatorText, formatLogisticianText, isStatusAfter } from './helpers'
import { SampleWithRequests } from 'views/pages/Samples/types'

interface Props {
  deal: Deal
  sample?: SampleWithRequests
}

export const DealCopyText = ({ deal, sample }: Props) => {
  const { t } = useTranslation('deal')
  const notify = useNotification()
  const handleFormatText = async (formatTextFunc, deal, sample) => {
    await formatTextFunc(deal, sample)
    notify(Progress.SUCCESS, { title: t('logistician_text_notification') })
  }

  const items = [
    {
      key: t('bid_for_coordinator'),
      label: (
        <div onClick={() => handleFormatText(formatCoordinatorText, deal, sample)}>{t('bid_for_coordinator')}</div>
      ),
    },
    {
      key: t('bid_for_carrier'),
      label: <div onClick={() => handleFormatText(formatLogisticianText, deal, sample)}>{t('bid_for_carrier')}</div>,
    },
  ]

  if (!isStatusAfter(deal.status, DealStatusTypes.AGREED)) return null

  return (
    <>
      <TooltipIcon isVisible text={t('copy_text_icon')}>
        <AntDropdown
          triggerElement={<AButton id="edit" size="medium" color="secondary" background="none" Icon={Icons.IconCopy} />}
          items={items}
        />
      </TooltipIcon>
    </>
  )
}
